var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highcharts',{ref:"chart",staticClass:"bar-chart",attrs:{"options":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }